import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit,} from "@angular/core";
import {AgentModel} from "../../../../agents/angular/models/agent.model";
import {DashboardsService} from "../../services/dashboards.service";
import {WidgetDatasourceEnum} from "../../../enums/widget-datasource.enum";

require('./dashboard-agents-table-view.scss');
@Component({
  standalone: false,
  selector: 'app-dashboard-agents-table-view',
  templateUrl: './dashboard-agents-table-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardAgentsTableViewComponent implements OnInit {

  @Input() filters: any;

  public agents: AgentModel[];
  public tableCursor: string;
  public isLoadingData: boolean;

  constructor(@Inject(DashboardsService) private dashboardsService: DashboardsService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.getTableWidgetData(this._getQueryPayload());
  }

  onQueryChange(query) {
    this.filters.query = query;
    this.getTableWidgetData(this._getQueryPayload());
  }

  getNextBatch() {
    if (this.tableCursor && !this.isLoadingData) {
      let filters = {
        ...this._getQueryPayload(),
        cursor: this.tableCursor
      };
      this.getTableWidgetData(filters, true)
    }
  }

  private getTableWidgetData(queryParams, isFetchNext?: boolean) {
    this.isLoadingData = true;
    this.dashboardsService.getDashboardWidgetData(WidgetDatasourceEnum.agentsDetails, queryParams).subscribe({
      next: (res) => {

        if (isFetchNext && this.agents.length) {
          this.agents = [...this.agents, ...res.list];
        } else {
          this.agents = res.list
        }

        this.tableCursor = res.cursor;
      },
      complete: () => {
        this.isLoadingData = false;
        this.cdr.detectChanges();
      }
    })
  }

  private _getQueryPayload() {
    return {
      ...this.filters,
      limit: 20
    };
  }


}
